// src/modules/app-views/_apps/appmulti/receivables/pages/Document/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { LinkOutlined, MoreOutlined, StopOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownNew,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';
import appService from 'services/appService';
import axiosService from 'services/axiosService';
import receivableService from 'services/receivableService';
import translateX from 'utils/translateX';
import { API } from 'constants/Api';

// *******************************************************************************
// CUSTOM ITEM: GENERATE PAYMENT LINK
// *******************************************************************************
const generatePaymentLinkItem = {
  key: 'generatePaymentLink',
  label: 'generate_billing',
  icon: <LinkOutlined />,
  hidden: ({ currentPage }) => {
    const d = currentPage?.data;
    if (!d?._id) return true;
    if (d?.paymentUrl) return true;
    return ['paid', 'received', 'cancelled', 'cancelled_by_customer'].includes(d?.status);
  },
  onClick: async ({ page, refreshDocument, apiGlobal }) => {
    const data = page?.data;
    if (!data?._id) return;

    appService.message({ flag: 'loading', text: 'generating_billing' });
    const updated = await receivableService.generatePaymentLink(data, true);
    appService.messageDestroy();

    if (updated?._id) {
      appService.notification({
        flag: 'success',
        title: translateX('payment_link_generated_success'),
        description: null,
        duration: 6,
      });
      if (typeof refreshDocument === 'function') refreshDocument();
      else apiGlobal?.refresh?.({ _id: data._id, showLoading: false });
    } else {
      appService.message({ flag: 'e', text: 'payment_link_generated_failure' });
    }
  },
};

// *******************************************************************************
// CUSTOM ITEM: CANCEL CHARGE
// *******************************************************************************
const cancelChargeItem = {
  key: 'cancelCharge',
  label: 'cancel',
  icon: <StopOutlined />,
  danger: true,
  hidden: ({ currentPage }) => {
    const d = currentPage?.data;
    if (!d?._id) return true;
    return ['paid', 'received', 'cancelled', 'cancelled_by_customer'].includes(d?.status);
  },
  onClick: ({ page, refreshDocument, apiGlobal }) => {
    const data = page?.data;
    if (!data?._id) return;

    appService.modal({
      flag: 'confirm',
      title: translateX('cancel_charge_confirm_title'),
      content: translateX('cancel_charge_confirm_description'),
      onOk: async () => {
        try {
          const url = API.RECEIVABLES.CANCEL_BY_ID.replace(':_id', data._id);
          const [updated] = await axiosService.put({ url, data: {} });
          if (updated?._id) {
            appService.message({ flag: 's', text: 'charge_cancelled_success' });
            if (typeof refreshDocument === 'function') refreshDocument();
            else apiGlobal?.refresh?.({ _id: data._id, showLoading: false });
          } else {
            appService.message({ flag: 'e', text: 'charge_cancelled_failure' });
          }
        } catch (error) {
          appService.message({ flag: 'e', text: 'charge_cancelled_failure' });
        }
      },
    });
  },
};

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const receivablesDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',
    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      generatePaymentLinkItem,
      cancelChargeItem,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default receivablesDocumentMenuButton;
